import React, { ReactElement } from 'react';
import { Button } from 'antd';

interface Props {
  breederId: number;
}

function RemoveBreederAdminManagedBreeder(props: Props): ReactElement {
  const { breederId } = props;

  return (
    <Button type="link" title={`Remove breed id ${breederId}`}>
      Remove
    </Button>
  );
}

export default RemoveBreederAdminManagedBreeder;
